export function isValidEmail(email) {
  if (email === "") return false;

  return /^(?!\d+@)[^\s@]+@[^\s@]*[a-zA-Z][^\s@]*\.[a-zA-Z]+$/.test(email);
}

export function isValidName(name) {
  if (name === "") return false;

  return /^[a-zA-Z\s]*$/.test(name);
}

export function isNotEmpty(value) {
  return value !== "";
}
